import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {FeatureBlock} from "@/pages/launchpad/FeatureBlock.tsx";
import {getAdditionalFeatures} from "@/pages/launchpad/featuresDef.tsx";

interface AdditionalFeaturesProps {
  firstDashboardID: number;
  enableStatusPages: boolean;
}

export const AdditionalFeatures = ({enableStatusPages, firstDashboardID}: AdditionalFeaturesProps) => {
  const features = getAdditionalFeatures({
    dashboardURL: `${URL_ORIGINAL_WEBSITE}/dashboard/${firstDashboardID}?pop=initial&gobackoncancel=true`,
    enableStatusPages: enableStatusPages,
  });
  return (
    <div>
      <div className="row mb-4">
        <h5>Additional features</h5>
      </div>
      <div className="row">
        {features.map((f, idx) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
            <FeatureBlock
              title={f.title}
              subtitle={f.subtitle}
              icon={f.icon}
              supportURL={f.supportURL}
              accessory={f.accessory}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
